import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { I18nService } from '@gruposaltaedu/liv-i18n/core';

import { isAppErrorCode } from '../helpers/is-app-error-code';
import { AppErrorNavigationService } from '../services/app-error-navigation.service';

function createNotFoundUrlTree() {
  const i18n = inject(I18nService);
  const router = inject(Router);
  return router.createUrlTree(['/', i18n.currentLanguage(), '404']);
}

/**
 * Só permite `/error/:code` quando a navegação veio de um erro real
 * (`AppErrorNavigationService`).
 */
export const errorPageAccessGuard: CanActivateFn = (route) => {
  const appErrorNavigation = inject(AppErrorNavigationService);
  const code = route.routeConfig?.path ?? route.url[0]?.path;

  if (!isAppErrorCode(code) || !appErrorNavigation.canAccess(code)) {
    return createNotFoundUrlTree();
  }

  return true;
};

/** Bloqueia `/error` sem código e manda para 404. */
export const errorIndexRedirectGuard: CanActivateFn = () =>
  createNotFoundUrlTree();
